<!-- Botón para alternar el estado del sidebar -->
<button class="z-10 fixed bottom-5 hover:cursor-pointer transition-all duration-300 ease-in-out"
  (click)="toggleSidebar()" [ngClass]="{ 'left-0': isHidden, 'left-[200px]': !isHidden }">
  <i class="pi text-black text-lg p-3 rounded-full border-2 border-white transition-all duration-300 ease-in-out"
    [ngClass]="{
      'pi-angle-right bg-[#01405c] text-white': isHidden,
      'pi-angle-left bg-[#e5e7eb] hover:bg-[#f9f9f9]': !isHidden,
    }"></i>
</button>

<div class="sidebar fixed left-0 bottom-0 flex-grow flex bg-[#01405c]" [ngClass]="{ open: !isHidden }">
  <div class="w-64 z-50 sidebar-menu transition-transform h-[calc(100vh-56px)] flex flex-col">
    <a [routerLink]="['/']" class="bg-[#01405c]" style="padding: 11px 20px">
      <img src="/ciberlens-logo.jpg" alt="CiberLens logo" class="sidebar-logo" aria-hidden="true" />
    </a>
    <div class="relative flex-grow">
      <ul class="">
        <!-- Opciones para CISO GLOBAL y CISO LOCAL -->
        @if (getUserRole() === 'CISO GLOBAL' || getUserRole() === 'CISO LOCAL') {
        <li class="mb-1 group">
          <a routerLink="/dashboard" routerLinkActive="bg-[#003a57]" [routerLinkActiveOptions]="{ exact: true }"
            class="flex font-semibold items-center py-4 px-12 hover:bg-[#004a6b] text-gray-100 group-[.active]:bg-gray-800 group-[.active]:text-white group-[.selected]:bg-gray-950 group-[.selected]:text-gray-100">
            <i class="pi pi-objects-column text-white text-lg pr-4"></i>
            <span class="text-sm">{{ 'dashboard.sidebar.option1' | translate }}</span>
          </a>
        </li>
        <li class="mb-1 group">
          <a routerLink="/entities" routerLinkActive="bg-[#003a57]" [routerLinkActiveOptions]="{ exact: true }"
            class="flex font-semibold items-center py-4 px-12 hover:bg-[#004a6b] text-gray-100 group-[.active]:bg-gray-800 group-[.active]:text-white group-[.selected]:bg-gray-950 group-[.selected]:text-gray-100">
            <i class="pi pi-sitemap text-white text-lg pr-4"></i>
            <span class="text-sm">{{ 'dashboard.sidebar.option2' | translate }}</span>
          </a>
        </li>
        <li class="mb-1 group">
          <a routerLink="/platforms" routerLinkActive="bg-[#003a57]" [routerLinkActiveOptions]="{ exact: true }"
            class="flex font-semibold items-center py-4 px-12 hover:bg-[#004a6b] text-gray-100 group-[.active]:bg-gray-800 group-[.active]:text-white group-[.selected]:bg-gray-950 group-[.selected]:text-gray-100">
            <i class="pi pi-building text-white text-lg pr-4"></i>
            <span class="text-sm">{{ 'dashboard.sidebar.option3' | translate }}</span>
          </a>
        </li>
        }

        <!-- Opciones para ADMINISTRATOR -->
        @if (getUserRole() === 'ADMINISTRATOR') {
        <li *ngFor="let item of menuItems" class="mb-1 group">
          <!-- Ítem con submenú -->
          <div *ngIf="item.children" (click)="toggleMenu(item)"
            class="flex cursor-pointer font-semibold items-center py-4 px-12 hover:bg-[#004a6b] text-gray-100">
            <i [class]="item.icon + ' text-white text-lg pr-4'"></i>
            <span class="text-sm">{{ item.title | translate }}</span>
            <i class="pi pi-chevron-right ml-auto transition-transform"
              [ngClass]="{ 'pi-chevron-down': item.isOpen }"></i>
          </div>

          <!-- Submenú de primer nivel -->
          <ul *ngIf="item.isOpen">
            <li *ngFor="let child of item.children" class="group">
              <!-- Ítem con submenú anidado (como Entities Manager) -->
              <div *ngIf="child.children" (click)="toggleMenu(child)"
                class="flex cursor-pointer font-semibold items-center py-3 pl-16 pr-12 hover:bg-[#004a6b] text-gray-100">
                <i [class]="child.icon + ' text-white text-sm pr-3'"></i>
                <span class="text-xs text-[14px]">{{ child.title | translate }}</span>
                <i class="pi pi-chevron-right ml-auto transition-transform"
                  [ngClass]="{ 'pi-chevron-down': child.isOpen }"></i>
              </div>

              <!-- Ítem sin submenú anidado -->
              <a *ngIf="!child.children" [routerLink]="child.routerLink"
                class="flex font-semibold items-center py-3 pl-16 pr-12 hover:bg-[#004a6b] text-gray-100">
                <i [class]="child.icon + ' text-white text-sm pr-3'"></i>
                <span class="text-xs text-[14px]">{{ child.title | translate }}</span>
              </a>

              <!-- Submenú anidado (para Entities Manager) -->
              <ul *ngIf="child.children && child.isOpen">
                <li *ngFor="let subChild of child.children" class="group">
                  <a [routerLink]="subChild.routerLink"
                    class="flex font-semibold items-center py-2 pl-20 pr-12 hover:bg-[#004a6b] text-gray-100">
                    <span class="text-xs text-[13px]">{{ subChild.title | translate }}</span>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        }
      </ul>
    </div>
  </div>
</div>
